import { render, staticRenderFns } from "./video-dialog.vue?vue&type=template&id=5662d243&scoped=true&"
import script from "./video-dialog.vue?vue&type=script&lang=js&"
export * from "./video-dialog.vue?vue&type=script&lang=js&"
import style0 from "./video-dialog.vue?vue&type=style&index=0&id=5662d243&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5662d243",
  null
  
)

export default component.exports